module.exports = __webpack_public_path__ + "media/images/malayalam-matrimony-banner-9c88048194618fe294fa88502adb0025.jpg";